SlideView  = require("views/slide")
{ Lesson } = Application.actions()

class ExitView extends SlideView
  template: require("./template")

  events: ->
    "click .btn": "exit"

  show: ->
    Lesson.complete()

  beforeShow: ->
    @trigger("ui", flexibleHeight: true)

  beforeHide: ->
    @trigger("ui", flexibleHeight: false)

module.exports = ExitView
